import { SECTION_TYPE } from "../../../Services/explore";
import TalkWithArisSection from "./TalkWithArisSection";
import RecommendedSection from "./RecommendedSection";
import ActiveDialoguesSection from "./ActiveDialoguesSection";
import PersonalDialoguesSection from "./PersonalDialoguesSection";
import LifeAreasSection from "./LifeAreasSection";
import OrganizationSection from "./OrganizationSection";
import ExpertDialoguesSection from "./ExpertDialoguesSection";
import CardListSection from "./CardListSection";
import { SECTION_COPY } from "../copy";
import "./style.css";

/**
 * Renders the feed in the order the backend sent it (guide §6.1 rule 1).
 *
 * Only LIFE_AREAS and TALK_WITH_ARIS are guaranteed present; every other
 * section is omitted rather than sent empty. So this switches on `type` and
 * skips anything it does not know how to draw — including the section types
 * v26.5 retired. Never index by position, never sort.
 */
function FeedSections({ feed, handlers }) {
  const sections = feed?.sections || [];

  return sections.map((section, index) => {
    const key = `${section?.type || "unknown"}-${index}`;

    switch (section?.type) {
      case SECTION_TYPE.RECOMMENDED_FOR_YOU:
        return (
          <RecommendedSection
            key={key}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
          />
        );

      case SECTION_TYPE.ACTIVE_DIALOGUES:
        return (
          <ActiveDialoguesSection
            key={key}
            section={section}
            onContinue={handlers.onContinueInstance}
            onOpen={handlers.onOpenActive}
            onViewAll={handlers.onViewAllActive}
          />
        );

      case SECTION_TYPE.PERSONAL_DIALOGUES:
        return (
          <PersonalDialoguesSection
            key={key}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
            onSeeAll={handlers.onSeeAllPersonal}
            onCapture={handlers.onCapture}
          />
        );

      case SECTION_TYPE.LIFE_AREAS:
        return (
          <LifeAreasSection
            key={key}
            section={section}
            onOpenLifeArea={handlers.onOpenLifeArea}
          />
        );

      case SECTION_TYPE.ORGANIZATION:
        return (
          <OrganizationSection
            key={key}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
          />
        );

      case SECTION_TYPE.EXPERT_DIALOGUES:
        return (
          <ExpertDialoguesSection
            key={key}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
          />
        );

      case SECTION_TYPE.HBR_DIALOGUES:
        return (
          <CardListSection
            key={key}
            title={SECTION_COPY.HBR_DIALOGUES.title}
            subtitle={SECTION_COPY.HBR_DIALOGUES.subtitle}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
          />
        );

      case SECTION_TYPE.SUGGESTED_ACTIONS:
        return (
          <CardListSection
            key={key}
            title={SECTION_COPY.SUGGESTED_ACTIONS.title}
            subtitle={SECTION_COPY.SUGGESTED_ACTIONS.subtitle}
            section={section}
            onOpenDialogue={handlers.onOpenDialogue}
          />
        );

      case SECTION_TYPE.TALK_WITH_ARIS:
        return (
          <TalkWithArisSection
            key={key}
            onTalkVoice={handlers.onTalkVoice}
            onTalkText={handlers.onTalkText}
          />
        );

      default:
        // An unrecognised or not-yet-implemented section is skipped silently:
        // the backend can add sections before this client knows them.
        return null;
    }
  });
}

export default FeedSections;
